const monthNames = [
    'Января',
    'Февраля',
    'Марта',
    'Апреля',
    'Мая',
    'Июня',
    'Июля',
    'Августа',
    'Сентября',
    'Октября',
    'Ноября',
    'Декабря',
];

/**
 * @returns {Function} Формирование даты из timestamp
 *
 * @param {Number} timestamp Время в секундах
 */
export default (timestamp) => {
    const date = new Date();
    date.setTime(timestamp * 1000);
    const year = date.getFullYear();
    const month = monthNames[date.getMonth()];
    const day = date.getDate();
    return `${day} ${month} ${year}`;
};

export const rusDateTime = dateStr => {
    const date = new Date(dateStr);

    return [
        [
            date.getDate(),
            monthNames[date.getMonth()].toLowerCase(),
            date.getFullYear(),
        ].join(' '),
        [
            date.getHours().toString().padStart(2, '0'),
            date.getMinutes().toString().padStart(2, '0'),
        ].join(':'),
    ].join(', ');
};

export const rusDate = dateStr => {
    const date = new Date(dateStr);

    return [
        date.getDate(),
        monthNames[date.getMonth()].toLowerCase(),
        date.getFullYear(),
    ].join(' ');
};
